// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sixteen-stories-sixteen-images-m__wrapper__1rXKN","dfp-ad-728x90":"sixteen-stories-sixteen-images-m__dfp-ad-728x90__171W2"};